import React from 'react';
import { motion } from 'framer-motion';
export function WhyDifferent() {
  return <section className="bg-gradient-to-br from-leather-dark to-leather-warm py-24 px-4 sm:px-6 lg:px-8 text-cream relative overflow-hidden" data-id="element-219">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12 relative z-10" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15
      }} className="lg:w-1/2" data-id="element-221">
          <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10" data-id="element-222">
            <img src="https://cdn.magicpatterns.com/uploads/mB3M4JAjEg3wBcrqARb28Z/Gemini_Generated_Image_iohqxfiohqxfiohq.png" alt="Biblioteca de Patrones Profesionales" className="w-full h-auto object-cover" data-id="element-223" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15,
        delay: 0.2
      }} className="lg:w-1/2 text-center lg:text-left" data-id="element-224">
          <h2 className="font-heading text-3xl md:text-5xl font-bold mb-8 text-gold" data-id="element-225">
            ¿Por qué este paquete es diferente al resto?
          </h2>
          <p className="text-lg sm:text-xl leading-relaxed mb-10 text-offwhite/90" data-id="element-226">
            En lugar de obligarte a comprar patrones sueltos a precios elevados,
            este paquete te entrega las llaves de una biblioteca de artículos de
            cuero{' '}
            <em className="text-gold not-italic font-semibold" data-id="element-227">
              en constante crecimiento
            </em>
            . Continuamente añadimos nuevos patrones y, a medida que la
            colección crezca, el precio de entrada aumentará.
          </p>
          <div className="bg-white/10 p-8 rounded-2xl border border-white/20 backdrop-blur-sm" data-id="element-228">
            <p className="text-xl sm:text-2xl font-heading font-bold mb-8" data-id="element-229">
              Accede ahora de forma segura, congela el precio actual y
              conviértete en dueño de toda la biblioteca hoy mismo.
            </p>
            <motion.a href="https://jg06af-rb.myshopify.com/checkouts/cn/hWNBgSWxNKncE70n6Yb5rGLa/es-ar?_r=AQAByHkJ8jcZdIvEe0H8ZdDRIkXMpmN5rxgoS347IycFAIY&preview_theme_id=133867339873" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block w-full sm:w-auto bg-gold hover:bg-gold-hover text-darktext font-bold text-lg px-8 py-4 rounded-xl shadow-lg" data-id="element-230">
              QUIERO MI BIBLIOTECA DE PATRONES »
            </motion.a>
            <img src="https://cdn.magicpatterns.com/uploads/rQtpQq5vqPSTqFzCkNLTaL/IMG-20260206-WA0094.jpg" alt="Pago seguro garantizado - Visa, Mastercard, Maestro, Mercado Pago" className="mt-6 w-full max-w-md mx-auto h-auto rounded-2xl" data-id="element-231" />
          </div>
        </motion.div>
      </div>
    </section>;
}